module.exports = __webpack_public_path__ + "static/media/dina.e1bed6a1.svg";